/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import Text from 'src/components/ts-components/Text'

interface ReadOnlyFieldProps {
  label: string
  /** The formatted value, or null to show the empty marker. */
  value: string | null
}

/** A field's label and saved value, for a section that is not being edited. */
const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({ label, value }) => (
  <div css={cellStyle}>
    <Text variant='paragraphSmall' weight='regular' color={colors.NEUTRAL_50}>
      {capitalizeWords(label)}
    </Text>
    <Text
      variant='paragraphSmall'
      weight='regular'
      color={value ? colors.WHITE : colors.NEUTRAL_100}
      style='white-space: pre-line; overflow-wrap: anywhere;'
    >
      {value ?? '—'}
    </Text>
  </div>
)

export default ReadOnlyField

// ---- styled ----
const cellStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`
